import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';

import { rem, colors, device } from '../lib/global-styles';
import { currencyFilter } from '../lib/utils';
import { swiperMobileParams } from '../lib/global-styles';
import arrowRight from '../images/arrow-primary-right.svg';
import { Title } from './Title';

const ComboGroupsBody = styled.div`
  p {
    color: ${colors.darkGrey};
    font-size: ${rem(16)};
    letter-spacing: ${rem(0.2)};
    line-height: ${rem(20)};
    margin-bottom: ${rem(16)};
  }
`;

const ComboGroupsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${rem(10)};
`;

const ComboGroupItem = styled.div`
  max-width: 28%;
  background: ${colors.white};
  border-radius: ${rem(10)};
  box-shadow: 0 ${rem(5)} ${rem(16)} 0 rgba(0, 0, 0, 0.1);
  padding: ${rem(20)} ${rem(16)};
  margin-bottom: ${rem(16)};

  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out, opacity 0.2s ease-out;
  transition-delay: 0.1s;

  h3 {
    display: flex;
    font-size: ${rem(16)};

    p {
      font-weight: normal;
    }

    img {
      height: ${rem(48)};
    }

    div {
      margin-left: ${rem(8)};
    }
  }

  .swiper-mobile {
    overflow: hidden;

    img {
      border-radius: ${rem(5)};
    }
  }

  &:hover {
    box-shadow: 0 ${rem(2)} ${rem(2)} rgba(0, 0, 0, 0.05), 0 ${rem(4)} ${rem(4)} rgba(0, 0, 0, 0.05),
      0 ${rem(16)} ${rem(16)} rgba(0, 0, 0, 0.05), 0 ${rem(32)} ${rem(32)} rgba(0, 0, 0, 0.05),
      0 ${rem(64)} ${rem(64)} rgba(0, 0, 0, 0.05);
    transform: translate(0, -${rem(5)});
  }

  @media ${device.mobile} {
    box-sizing: border-box;
    max-width: 100%;
  }
`;

const ComboGroupItemFooter = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(14)};
  margin-top: ${rem(10)};

  p {
    margin: ${rem(10)} 0 0 0;

    span {
      font-weight: bold;
      font-size: ${rem(14)};
    }
  }

  a {
    padding-right: ${rem(20)};
    background: url(${arrowRight}) no-repeat right;
    color: ${colors.primary};
    margin-left: auto;
    font-weight: bold;
    text-decoration: none;
  }
`;

class ComboGroups extends Component {
  state = {
    swiperMobileParams: { ...swiperMobileParams },
  };

  render() {
    const { products } = this.props;
    const comboProducts = products.filter(
      (product, pos, self) =>
        product.isCombo && self.findIndex(v => v.combo.name === product.combo.name) === pos,
    );

    return (
      <ComboGroupsBody>
        <Title>
          Com os Recorrentes Combos, você pode programar sua recarga com seu opcional favorito
        </Title>
        <p>Turbine sua programação com filmes, séries ou futebol.</p>
        <ComboGroupsWrapper>
          {comboProducts.map((product, key) => (
            <ComboGroupItem key={key}>
              <h3>
                <img alt="canal" src={product.combo.logo} />
                <div>
                  Canal {product.combo.name}
                  <p>{product.combo.shortDescription}</p>
                </div>
              </h3>
              <Swiper {...swiperMobileParams}>
                {product.combo.images.map((image, key) => (
                  <img key={key} alt="canal" src={image} />
                ))}
              </Swiper>
              <ComboGroupItemFooter>
                <p>
                  A partir de <span>{currencyFilter(product.combo.startPrice)}</span>
                </p>
                <Link to={`/recarga-opcional/${product.combo.name.toLowerCase()}`}>Saiba mais</Link>
              </ComboGroupItemFooter>
            </ComboGroupItem>
          ))}
        </ComboGroupsWrapper>
      </ComboGroupsBody>
    );
  }
}

export default ComboGroups;
